import { useQuery } from '@tanstack/react-query';

import { type Student } from '~entities/student/modal/student';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

interface GetClassAttendanceParams {
  classId: string;
  date: string;
}

export const getActiveClassAttendanceAPI = async (
  params: GetClassAttendanceParams,
) => {
  const response = await baseAPI.get<Array<Student>>(
    `/students/class/studio/all/active`,
    {
      params: {
        enrollmentId: params.classId,
        date: params.date,
      },
    },
  );
  return response.data;
};

export const useGetActiveClassAttendanceByDate = (
  params: GetClassAttendanceParams,
) => {
  return useQuery({
    queryKey: [KEYS.ATTENDANCE, params.classId, params.date],
    queryFn: () => getActiveClassAttendanceAPI(params),
    staleTime: 1000 * 60 * 5,
  });
};
